import { useState } from "react";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import html2pdf from "html2pdf.js";
import toast from "react-hot-toast";

const useReport = (devoteeData, watch) => {
  const [data, setData] = useState(null);

  const handleDownload = () => {
    const element = document.getElementById("report");
    html2pdf()
      .set({
        margin: 0,
        filename: "DevoteeReport.pdf",
        html2canvas: { scale: 1 },
        jsPDF: { orientation: "portrait" },
      })
      .from(element)
      .save();
  };

  const onSubmit = async (formData) => {
    if (formData?.service || formData?.donation) {
      formData.user_id = devoteeData?.user_id;
      try {
        const response = await postApi(apiEndPoints.getReportDetail, formData);
        if (response?.data?.status === 1) {
          setData(response?.data?.data);
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message || "Something Went Wrong");
        }
      } catch (error) {
        toast.error(`Request failed: ${error.message}`);
      }
    } else {
      toast.error("Please Select at least one from Service or Donation");
    }
  };

  const sendMail = async () => {
    try {
      const payload = {
        user_id: devoteeData?.user_id,
        service: watch("service"),
        donation: watch("donation"),
        year: watch("year"),
      };
      const response = await postApi(apiEndPoints.sendReportMail, payload);
      if (response?.data?.status === 1) {
        setData(response?.data?.data);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message || "Something Went Wrong");
      }
    } catch (error) {
      console.error("Mail error:", error);
      toast.error("Something Went Wrong");
    }
  };

  return {
    data,
    setData,
    handleDownload,
    onSubmit,
    sendMail,
  };
};

export default useReport;
